import {
  VerificationLevel,
  VerificationLevels
} from "@wingspanhq/wingspan-api-sdk";
import { getCustomerEntity } from "../../../services/api/onboarding/customer";

export const selectorIsUsPersonVerificationAvailable = (
  monitoredEntity: Awaited<ReturnType<typeof getCustomerEntity>> | undefined,
  verifications: VerificationLevels | undefined
) => {
  const country = monitoredEntity?.country;
  const type = monitoredEntity?.type;
  const usVerificationStatus = verifications?.profiles?.["US"]?.tax;

  const isNonUSUser = country ? country !== "US" : false;
  const isIndividual = type === "Individual";
  const isUSUsedNonVerified =
    usVerificationStatus !== VerificationLevel.VERIFIED &&
    usVerificationStatus !== VerificationLevel.PENDING;

  return isNonUSUser && isIndividual && isUSUsedNonVerified;
};
